import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    content: {
        padding: theme.spacing(3),
    },
    action: {
        marginTop: theme.spacing(3),
        minWidth: 100,
    },
    formControl: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    roleControl: {
        marginTop: theme.spacing(2),
    },
    linkcontrol: {
        margin: theme.spacing(1),
    },
    datepicker: {
        width: '100%'
    },
}))

export default useStyles
